import React from "react";
import { Outlet } from "react-router-dom";

export default function AdminInnerPanelLayout() {
  return (
    <div>
      <Outlet></Outlet>
    </div>
  );
}
